export function getElementHeight(el?: HTMLElement | null, ignoreMargins?: boolean): number {
  if (!el) {
    return 0;
  }

  const styles = document.defaultView?.getComputedStyle(el);
  return (
    el.getBoundingClientRect().height +
    (ignoreMargins ? 0 : parseInt(styles?.marginTop ?? '0') + parseInt(styles?.marginBottom ?? '0'))
  );
}

export function getElementWidth(el?: HTMLElement | null, ignoreMargins?: boolean): number {
  if (!el) {
    return 0;
  }

  const styles = document.defaultView?.getComputedStyle(el);
  return (
    el.getBoundingClientRect().width +
    (ignoreMargins ? 0 : parseInt(styles?.marginLeft ?? '0') + parseInt(styles?.marginRight ?? '0'))
  );
}

export function getElementMarginTop(el?: HTMLElement | null): number {
  if (!el) {
    return 0;
  }

  const styles = document.defaultView?.getComputedStyle(el);
  return parseInt(styles?.marginTop ?? '0');
}

export function getElementMarginBottom(el?: HTMLElement | null): number {
  if (!el) {
    return 0;
  }

  const styles = document.defaultView?.getComputedStyle(el);
  return parseInt(styles?.marginBottom ?? '0');
}

export function getElementMarginLeft(el?: HTMLElement | null): number {
  if (!el) {
    return 0;
  }

  const styles = document.defaultView?.getComputedStyle(el);
  return parseInt(styles?.marginLeft ?? '0');
}

export function getElementMarginRight(el?: HTMLElement | null): number {
  if (!el) {
    return 0;
  }

  const styles = document.defaultView?.getComputedStyle(el);
  return parseInt(styles?.marginRight ?? '0');
}

export function getElementPaddingTop(el?: HTMLElement | null): number {
  if (!el) {
    return 0;
  }

  const styles = document.defaultView?.getComputedStyle(el);
  return parseInt(styles?.paddingTop ?? '0');
}

export function getElementPaddingBottom(el?: HTMLElement | null): number {
  if (!el) {
    return 0;
  }

  const styles = document.defaultView?.getComputedStyle(el);
  return parseInt(styles?.paddingBottom ?? '0');
}

export function getElementPaddingLeft(el?: HTMLElement | null): number {
  if (!el) {
    return 0;
  }

  const styles = document.defaultView?.getComputedStyle(el);
  return parseInt(styles?.paddingLeft ?? '0');
}

export function getElementPaddingRight(el?: HTMLElement | null): number {
  if (!el) {
    return 0;
  }

  const styles = document.defaultView?.getComputedStyle(el);
  return parseInt(styles?.paddingRight ?? '0');
}
